<div class="father">

  <div class="title">
    <h2>Cuenta regresiva</h2>
  </div>
<div class="countdown-container">

  <div class="time-box">
    <div class="circle">{{days}}</div>
    <span>DÍAS</span>
  </div>

  <div class="time-box">
    <div class="circle">{{hours}}</div>
    <span>HORAS</span>
  </div>

  <div class="time-box">
    <div class="circle">{{mins}}</div>
    <span>MINUTOS</span>
  </div>

  <div class="time-box">
    <div class="circle">{{seconds}}</div>
    <span>SEGUNDOS</span>
  </div>

</div>

<div class="button-container">
  <button class="buttonDate" (click)="schedule()">AGENDAR FECHA</button>
</div>

</div>